import { create } from "zustand"
import { combine, persist } from "zustand/middleware"
import { Study } from "../types/types"

export const useWelcomeStore = create(
  persist(
    combine(
      {
        studyId: null as undefined | null | string,
        study: null as Study | undefined | null,
        token: null as undefined | null | string
      },
      (set) => ({
        setStudyId: (studyId: string | null) => set({ studyId }),
        setStudy: (study: Study | null) => set({ study }),
        setToken: (token: string | null) => set({ token }),
        reset: () => set({ studyId: null, study: null, token: null })
      })
    ),
    { name: "welcome" }
  )
)
